import type { dynamicObj } from 'src/pages/assets';

export class ApiError extends Error {
  public metadata;
  public success = false;
  public status: string | number = '';

  constructor(metadata: dynamicObj) {
    super();
    this.name = 'ApiError';
    this.metadata = metadata;
    this.convertError();

    if (!this.message || this.message.trim() === '') {
      this.message = 'Unknown API Error';
    }

    this.handleApiKeyError();
  }

  convertError() {
    this.status = '';
    this.success = false;

    if (!this.metadata?.response) {
      if (this.metadata?.request) {
        this.message = this.metadata.message || 'Network error - no response received';
      } else if (this.metadata?.message) {
        this.message = this.metadata.message;
      }
      return;
    }

    if (this.metadata.response.status !== undefined) {
      this.status = this.metadata.response.status;
    }

    if (!this.metadata.response.data) {
      if (this.metadata.response.statusText) {
        this.message = this.metadata.response.statusText;
      }
      return;
    }

    const data = this.metadata.response.data;

    if (data.success !== undefined) {
      this.success = data.success;
    }

    if (data.message) {
      this.message = data.message;
    } else if (data.detail) {
      this.message = typeof data.detail === 'string' ? data.detail : JSON.stringify(data.detail);
    } else if (data.error_description) {
      this.message = data.error_description;
    } else if (this.metadata.message) {
      this.message = this.metadata.message;
    }
  }

  async handleApiKeyError() {
    if (this.message && typeof this.message === 'string' && this.message.toLowerCase().includes('invalid key')) {
      try {
        const { useAuthTokenStore } = await import('src/store/main');
        const auth_token_store = useAuthTokenStore();
        auth_token_store.tryToRefreshToken(true);
      } catch (e) {
        // Ignore errors if store isn't ready
      }
    }
  }
}

export class RequestCancelError extends Error {
  public metadata;
  public success = false;
  public status: string | number = '';

  constructor(metadata: dynamicObj) {
    super('cancelled');
    this.name = 'RequestCancelError';
    this.metadata = metadata;
    this.convertError();
  }

  convertError() {
    this.status = 'cancelled';
    this.success = false;
    this.message = 'cancelled';
  }
}

export class ValidationError extends Error {
  constructor(message: any) {
    super(message);
    this.name = 'ValidationError';
    this.message = message;
  }
}

export class PermissionError extends Error {
  constructor(message: any) {
    super(message);
    this.name = 'PermissionError';
    this.message = message;
  }
}

export class DatabaseError extends Error {
  constructor(message: any) {
    super(message);
    this.name = 'DatabaseError';
    this.message = message;
  }
}
